import clsx from "clsx";

import { useStyles } from "./PageTitle.styles";
import { PageTitleActions } from "./PageTitleActions";
import type { PageTitleProps } from "./types";

/**
 * Page title component, used to display a title and optional actions.
 */
const PageTitle = ({ actions, overrideCase, "data-testid": testId, title }: PageTitleProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h1 data-testid={testId} className={clsx(classes.title, overrideCase && classes.titleOverrideCase)}>
        {title}
      </h1>
      <PageTitleActions actions={actions} />
    </div>
  );
};

export { PageTitle };
